import React, { Component } from 'react';

import PropTypes from 'prop-types';
import { Typography } from '@telus-uds/components-web';

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    console.log('getDerivedStateFromError Error ----------', error);
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log('componentDidCatch Errors ----------------', error, errorInfo);
    // logErrorToMyService(error, errorInfo);
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      // You can render any custom fallback UI
      return (
        <Typography heading="h3" variant={{ size: 'h3' }} block>
          This webform is temporarily unavailable. Please try accessing it again
          in a few minutes. If the issue persists, please submit an issue under{' '}
          <a
            href="https://www.mysalesorders.com/en-US/report-an-issue"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: '#4b286d' }}
          >
            Report an Issue
          </a>
        </Typography>
      );
    }

    return children;
  }
}

ErrorBoundary.defaultProps = {
  children: null
};

ErrorBoundary.propTypes = {
  children: PropTypes.node
};
export default ErrorBoundary;
